module.exports = __webpack_public_path__ + "slider-04@2x.jpg?da9a3e7a8c3d9d1bd21824ea5e64174d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-04@2x.jpg
// module id = 269
// module chunks = 0